import React from 'react';
import captchaLogo from '../../shared/assets/images/captchaLogo.png';
import lang from '../../lang/lang.json';
import { useSelector } from 'react-redux';
import './captchamodal.scss';

const ModalCaptcha = ({
  img,
  handleCloseCaptcha,
  handleCaptchaInput,
  captchaInput,
  onCaptchaSend,
  checkCaptchaType,
}) => {
  const { language } = useSelector((state) => state.language);

  return (
    <div className="modal-background">
      {/* <div className="captcha-modal-wrap"></div> */}
      <div className="captcha-modal">
        <div className="captcha-modal-wrap">
          <div className="exit-div">
            <div onClick={handleCloseCaptcha} className="exitModal">
              <svg
                style={{ pointerEvent: 'none' }}
                width="20"
                height="18"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.00011 4.82178L10.1251 0.696777L11.3034 1.87511L7.17844 6.00011L11.3034 10.1251L10.1251 11.3034L6.00011 7.17844L1.87511 11.3034L0.696777 10.1251L4.82178 6.00011L0.696777 1.87511L1.87511 0.696777L6.00011 4.82178Z"
                  fill="#455976"
                />
              </svg>
            </div>
          </div>
          <div className="captcha-modal-body">
            <div>
              <img src={captchaLogo} alt="" />
            </div>
            <div className="captcha-title">
              {lang.CAPTCHA_MODAL_TEXT[language]}
            </div>
            <div>
              <img src={img} alt="" />
            </div>
          </div>
          <div className="captcha-modal-footer">
            <div>
              <label htmlFor="name" className="input-tite">
                {lang.CAPTCHA_MODAL_TEXT[language]}
              </label>
              <input
                onChange={handleCaptchaInput}
                value={captchaInput}
                type="text"
                className="modal-captcha-input"
              />
              <div>
                <button
                  onClick={onCaptchaSend}
                  className="modal-captcha-button"
                >
                  {lang.PHONE_SMS_BUTTON[language]}
                </button>
                <span className="captchaError"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalCaptcha;
